export default __webpack_public_path__ + "static/media/CNo.56-0.b0be9db7.jpg";